import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { RideStartStatusEnum } from "@ryde/shared";

import { buildLiveMapRideStartStatusBadgePalette } from "../../../utils";
import { LiveMapStatusBadgeStyled } from "./live-map-status-badge.styled";

export interface ILiveMapRideStartStatusBadge {
  status?: RideStartStatusEnum | null;
}

/** Live-map "Start on time" badge (RYDE-7685). Absent status renders the grey "No Data" state. */
export const LiveMapRideStartStatusBadge: FC<ILiveMapRideStartStatusBadge> = ({
  status,
}) => {
  const { t } = useTranslation();

  // Grid rows without a value pass "" (not undefined) — any unknown/falsy value is "No Data".
  const resolvedStatus =
    status && Object.values(RideStartStatusEnum).includes(status)
      ? status
      : undefined;

  const palette = useMemo(
    () => buildLiveMapRideStartStatusBadgePalette(resolvedStatus),
    [resolvedStatus],
  );

  return (
    <LiveMapStatusBadgeStyled
      $backgroundColor={palette.backgroundColor}
      $borderColor={palette.borderColor}
      $color={palette.color}
      $dataE2e="live-map-ride-start-status-badge"
    >
      {t(`rideMap.rideStartStatus.${resolvedStatus ?? "NoData"}`)}
    </LiveMapStatusBadgeStyled>
  );
};
